function firstLowest(best, value) {
  return value < best;
}

exports.firstLowest = firstLowest;